import React from 'react';

export default function Impressum() {
  return (
    <main className="impressum page-root">
      <div className="container" style={{maxWidth:980,margin:'0 auto',padding:'56px 24px'}}>
        <div style={{background:'linear-gradient(180deg, rgba(255,255,255,0.02), rgba(255,255,255,0.01))',padding:28,borderRadius:12}}>
          <h1 style={{fontFamily:'Bebas Neue, sans-serif',fontSize:'2.8rem',marginBottom:12,color:'var(--accent)'}}>Impressum</h1>

          <section style={{marginBottom:20}}>
            <h2 style={{fontSize:'1.15rem',marginBottom:8}}>Angaben gemäß § 5 TMG</h2>
            <address style={{lineHeight:1.5,fontStyle:'normal'}}>
              Liberty Street Food GmbH<br />
              Saaleweg 16<br />
              63071 Offenbach<br />
              Deutschland
            </address>
          </section>

          <section style={{marginBottom:20}}>
            <h2 style={{fontSize:'1.15rem',marginBottom:8}}>Geschäftsführer</h2>
            <p>Maximilian Brenner</p>
          </section>

          <section style={{marginBottom:20}}>
            <h2 style={{fontSize:'1.15rem',marginBottom:8}}>Handelsregister</h2>
            <p>Amtsgericht Offenbach am Main · HRB 58431</p>
          </section>

          <section style={{marginBottom:20}}>
            <h2 style={{fontSize:'1.15rem',marginBottom:8}}>Umsatzsteuer-ID</h2>
            <p>DE458399062</p>
          </section>

          <section style={{marginBottom:20}}>
            <h2 style={{fontSize:'1.15rem',marginBottom:8}}>Kontakt</h2>
            <p>Telefon: 0155 11522559<br />E-Mail: info@libertystreetfood.de</p>
          </section>

        </div>
      </div>
    </main>
  );
}
